import React, { ReactNode, useEffect } from 'react'
import { AutoComplete } from 'antd'
import { SelectProps } from 'antd/es/select'
// import { querySchoolList } from 'servers/common'
import { debounce } from 'lodash-es'
// import useStore from 'store'
import s from './index.module.less'
import Search from './images/Search.png'

const { Option } = AutoComplete

interface IProps {
  searchPlaceholder?: string
  notFoundContent?: string
  handleChange: Function
  handleSearch: Function
  searchRes: SelectProps<object>['options']
  clickSearch: () => void
  needOptions?: Boolean // 是否需要自定义options
  optionsNode?: ReactNode | null // 是否需要自定义options
  curValue: string // 有效搜索的值（需要记历史记录）
  historyName: string // 存储历史记录指定key
  setSearchRes: Function // 获取历史记录
  inputWidth?: number // 输入框宽度
}

const FillSearch: React.FC<IProps> = ({
  searchPlaceholder,
  notFoundContent,
  handleChange,
  handleSearch,
  searchRes,
  clickSearch,
  needOptions,
  optionsNode,
  curValue,
  historyName,
  setSearchRes,
  inputWidth
}) => {
  const handleFocus = () => {
    // @ts-ignore
    setSearchRes(
      (window.localStorage[historyName] &&
        JSON.parse(window.localStorage[historyName])?.slice(0, 10)) ||
        []
    )
  }

  useEffect(() => {
    // 存储历史记录
    if (curValue) {
      // @ts-ignore
      const now = (
        (window.localStorage[historyName] && JSON.parse(window.localStorage[historyName])) ||
        []
      ).filter((v) => v.historyValue !== curValue)
      // @ts-ignore
      window.localStorage.setItem(
        historyName,
        JSON.stringify([{ historyValue: curValue }, ...now.slice(0, 10)])
      )
    }
  }, [curValue])

  return (
    <div className={s.FillSearch}>
      <AutoComplete
        placeholder={searchPlaceholder}
        dropdownMatchSelectWidth={230}
        style={{ width: inputWidth }}
        onSearch={debounce(handleSearch, 500)}
        onSelect={(e) => handleChange(e)}
        onFocus={handleFocus}
        allowClear
        notFoundContent={notFoundContent}
      >
        {needOptions
          ? optionsNode
          : searchRes?.map((v) => (
              <Option value={v.historyValue} key={v.historyValue}>
                {v.historyValue}
              </Option>
            ))}
      </AutoComplete>
      <button type="button" className={`${s.searchIcon}`} onClick={clickSearch}>
        <img src={Search} alt="search" />
      </button>
    </div>
  )
}

FillSearch.defaultProps = {
  searchPlaceholder: '搜索意向院校',
  notFoundContent: '找到符合条件的学校0所',
  needOptions: false,
  optionsNode: null,
  inputWidth: 190
}

export default FillSearch
